export const options = [
    { value: 'AL', label: 'Alabama' },
    { value: 'WY', label: 'Wyoming' },
    { value: 'CO', label: 'Coming' },
    { value: 'HD', label: 'Hanry Die' },
    { value: 'JD', label: 'John Doe' },
];

export const options2 = [
    { label: 'Developer', isDisabled: true },
    { value: 'AL', label: 'Alabama' },
    { value: 'WY', label: 'Wyoming' },
    { label: 'Designer', isDisabled: true },
    { value: 'CO', label: 'Coming' },
    { value: 'HD', label: 'Hanry Die' },
    { value: 'JD', label: 'John Doe' },
];

export const options3 = [
    { value: 'FR', label: 'First' },
    { value: 'SE', label: 'Second', isDisabled: true },
    { value: 'TH', label: 'Third' },
];

export const options4 = [
    { label: 'Developer', isDisabled: true },
    { value: 'AL', label: 'Alabama' },
    { value: 'WY', label: 'Wyoming' },
    { value: 'CO', label: 'Coming' },
    { value: 'HD', label: 'Hanry Die' },
    { value: 'JD', label: 'John Doe' },
];

export const OutlineColors = [
    { value: 'opt1', label: 'Select One Value Only' },
    { value: 'opt2', label: 'Type 2' },
    { value: 'opt3', label: 'Type 3' },
    { value: 'opt4', label: 'Type 4' },
    { value: 'opt5', label: 'Type 5' },
    { value: 'opt6', label: 'Type 6' },
    { value: 'opt7', label: 'Type 7' },
    { value: 'opt8', label: 'Type 8' },
]